export default {
  errors: {
    wrong_brn_format: "Wrong BRN format",
    db_query_failed: "Error database connection",
    db_fetch_failed: "Error reading from the database",
    permission_denied: "You do not have permission to use this system",
    // msw: "Error MSW API connection",
    msw_unknown_result: "Error reading from MSW API",
    invalid_param: "The parameter provided is incorrect.",
    invalid_date: "The parameter date is incorrect.",
    invalid_date_range: "The parameter date range are incorrect.",
    invalid_date_range_over_60: "The selected period is more than  60 days",
    invalid_date_range_over_90: "The selected period is more than  90 days",
    invalid_keyword_number: "The parameter keyword is incorrect.",
    twofa_code: "OTP Error ({0})",
    twofa: {
      S_AUT_00000: "Success",
      B_AUT_00001: "The use name or password is incorrect",
      B_AUT_00002: "Password is incorrect ",
      B_AUT_00402:
        "The system is currently unavailable. Please try again later.",
      B_AUT_00403:
        "The system is currently unavailable. Please try again later.",
      B_AUT_00404:
        "The system is currently unavailable. Please try again later.",
      B_AUT_99999:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00101:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00102:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00103:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00405:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00503:
        "The system is currently under maintenance. Please try again later.",
      T_AUT_00901:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00902:
        "The system is currently unavailable. Please try again later.",
      T_AUT_99999:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00101:
        "The system is currently unavailable. Please try again later.",
      T_AUT_00102:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00403:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00404:
        "The system is currently unavailable. Please try again later.",
      B_SRV_00406: "The OTP phone number provided is incorrect",
      B_SRV_00410:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61001:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61002:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61003:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61004:
        "The system is currently unavailable. Please try again later.",
      B_SRV_61005:
        "The OTP phone number provided is terminated. Please contact dtac call center 1431",
      B_SRV_61006: "The OTP phone number provided is incorrect",
      B_SRV_61007:
        "System is locked due to reach max attempt. Please try again in 15 minutes",
      B_SRV_61009: "OTP is incorrect. Please try again",
      B_SRV_61010: "OTP has expired. Please try again",
      B_SRV_61011: "OTP is incorrect. Please try again",
      B_SRV_61012: "OTP is not match for 3 times",
      B_SRV_61013: "OTP is incorrect. Please try again",
      B_SRV_99999:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00101:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00102:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00103:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00405:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00503:
        "The system is currently under maintenance. Please try again later.",
      T_SRV_00901:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00902:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00904:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00905:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00906:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00907:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00908:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00909:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00910:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13001:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13003:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13004:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13005:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13006:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13002:
        "The system is currently unavailable. Please try again later.",
      T_SRV_13000:
        "The system is currently unavailable. Please try again later.",
      T_SRV_99999:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00101:
        "The system is currently unavailable. Please try again later.",
      T_SRV_00102:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00401:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00498:
        "The system is currently unavailable. Please try again later.",
      T_ESV_00502:
        "The system is currently unavailable. Please try again later."
    },
    msw: {
      numberblock_add_failed: "Create Number Block failed",
      number_create_failed: "Could not add this phone number to the system",
      delete_pirot_dummy_failed:
        "Could not delete pilot number from the system ",
      number_delete_failed:
        "Could not delete this phone number from the system",
      voicemail_failed: "Could not process Voicemail"
    },
    dtac: {
      idcard_validate_fail: "This BRN could not be found",
      subs_query_status_failed:
        "This phone number cannot be found on dtac's system.",
      subs_query_package_failed:
        "No information of this package was found on dtac's system.",
      wci_failed: "Could not create or add this phone number.",
      unknown_result: "Error reading from DTAC API",
      wci_queue: "Creating number in queue"
    },
    user: {
      duplicate: "Duplicate User information",
      duplicate_username: "Duplicate Username information",
      duplicate_email: "Duplicate email information",
      blcok_delete_by_self: "Can't delete data by yourself.",
      fail: "Error update user information",
      email_wrong_format: "Wrong email format",
      enterprise_empty: "Please select Enterprise",
      name_empty: "Please input Name",
      phone_wrong_format: "Wrong phone number"
    },
    corp: {
      wrong_type: "Error invalid corporate type",
      wrong_format: "Wrong Corporate name format",
      duplicate: "Duplicate Corporate information",
      not_exist: "Organization information not found",
      check_number_fail: "The number checking is fail.",
      number_exist: "Error found number in Corporate",
      failed: "Error update Corporate information",
      create_failed: "Error create Corporate information",
      delete_failed: "Error delete Corporate information",
      user_exist: "Error found user in Corporate"
    },
    mlhg: {
      duplicate: "Duplicate Muti-line Hunting Group information",
      get_dummy_number_fail:
        "Information for dummy number for MLHG is not found",
      not_exist: "Not found this MLHG Information",
      member_not_exist: "Not found this number in this MLHG",
      member_not_in_corp: "Not found this number in this Enterprise",
      get_enterprise_fail: "Not found this Corporate",
      get_mlhg_fail: "Not found this MLHG",
      get_number_fail: "Not found this Number",
      get_pilot_fail: "Not found this Company Number",
      update_number_fail: "Update number in this MLHG failed",
      delete_number_fail: "Delete number in this MLHG failed",
      redeem_dummy_pilot_failed: "Cannot redeem dummy number",
      number_duplicate: "This number is duplicate in this MLHG",
      invalid_parameter: "Invalid parameter",
      access_denie: "Access Denie"
    },
    auth: {
      login_fail: "Login Fail",
      block: "User has been blocked",
      login_success: "Login Success",
      logout_success: "Log out Success",
      unauthoriezed: "No permission",
      reset_invalid_token: "token invalid",
      reset_token_expired: "token reset_token_expired",
      forgot_password_fail: "forgot password failed",
      reset_password_fail: "reset password failed",
      username_wrong_format: "Wrong username format",
      password_wrong_format: "Wrong password format",
      token: "Invalid Token",
      password: "Invalid password",
      password_confirm: "Invalid confirm password",
      twofafail: "Request OTP failed",
      request_twofa_fail: "Request OTP failed",
      verify_twofa_fail: "Verify OTP failed"
    },
    otp: {
      request_otp_fail: "Request OTP failed",
      verify_otp_fail: "Verify OTP failed"
    },
    package: {
      duplicate_code: "Package Code is Duplicate",
      duplicate_name: "Package Name is Duplicate",
      not_exist: "not found package information",
      delete_lock: "Cannot delete this package Because it is in use",
      get_profile_failed: "The VPBX package could not be found in the system."
    },
    subs: {
      invalid_number: "Invalid Number",
      invalid_mapping_number: "Invalid Mapping Number",
      invalid_agent_number: "Wrong agent number format",
      invalid_main_number: "Wrong enterprise number format",
      invalid_charge_number: "Wrong charge number format",
      invalid_alt_number: "Wrong alternative number format",
      invalid_real_number: "Wrong real number format",
      invalid_additional_number: "Wrong additional number format",
      invalid_email: "Invalid E-Mail",
      not_exist: "This Number not exist",
      corp_not_match: "Corporate information not match",
      get_crop_id_failed: "Not found Corporate information or Company Number",
      comp_login_failed: "Cannot login to ComPortal",
      duplicate: "Duplicate Number",
      get_charge_number_failed:
        "Could not find telephone number information under this company.",
      set_charge_number_failed: " This phone number cannot be changed.",
      get_brn_failed: "Not found this BRN",
      is_mlhg_member: "This number is member of MLHG",
      number_range_delete_fail: "Cannot delete Number Range",
      comp_login_failed: "Error Login to ComPortal",
      subs_status_failed:
        "This Number is not eligible to subscribe this service",
      import_number: "Import number failed",
      reset_password_fail: "Reset password failed",
      delete_failed: "Delete number failed",
      delete_number_block_failed: "Delete Number Block failed",
      number_in_mlhg: "This number is pilot of MLHG"
    },
    profile: {
      get_profile_failed: "Get profile failed",
      change_profile_failed: "Change profile failed",
      change_password_failed: "Change password failed",
      password_confirm_not_match: "Error confirm password",
      password_confirm_wrong_format: "Wrogn password format.",
      password_old_wrong: "Wrong old password"
    },
    report: {
      date_over_60: "The selected period is more than 60 days",
      date_over_90: "The selected period is more than 90 days",
      date_over_30:
        "The maximum search period is 90 days. For query mor than 30 days, it will take longer than usual."
    }
  },

  bc_portal: "Web Portal",
  bc_package: "Package",
  bc_voicemail: "Voice Mail",
  bc_report: "Report",
  bc_record: "Record Detail",
  bc_user: "User",
  bc_corporate: "Corporate",
  bc_mlhg: "Hunt Group",
  bc_pilot_number: "Company Number",
  bc_agent_number: "User Number",
  bc_mapping_number: "Mapping Number",
  bc_import_number: "Import User Number",
  bc_change_profile: "Edit Profile",
  bc_change_password: "Edit Password",

  profile: {
    profile: "Profile",
    name: "Name",
    phone: "Phone",
    email: "E-Mail",
    change_password: "Change Password",
    password_old: "Old Password",
    password_new: "New Password",
    password_confirm: "Confirm Password",
    change_profile_success: "Change profile successed",
    change_password_success: "Change password successed",
    forgot_password_success:
      "Forgot password successed , Please check your email.",
    reset_password_success: "Reset password successed"
  },
  menu: {
    corporate: "Corporate",
    mlhg: "Hunt Group",
    package: "Package",
    pilot_number: "Company Number",
    agent_number: "User Number",
    import_agent_number: "Import User Number",
    number: "Number",
    user: "User",
    voicemail: "Voice Mail",
    cdr: "Record Detail",
    report: "Report",
    nseries: "Voice Conference"
  },
  auth: {
    signin: "Sign In",
    signout: "Logout",
    username: "E-Mail or Number",
    email: "E-Mail",
    password: "Password",
    forgetpassword: "Forgot Password",
    resetpassword: "Reset Password",
    twofa: "Confirm OTP",
    twofa_send_to: "Your OTP code has been sent via sms to {0}",
    otp_ref_code: "(OTP Reference Code: {0})",
    refcode: "Ref Code",
    otpcode: "OTP Code",
    requestotp: "Request OTP",
    requestnewotp: "Request New  OTP in {0} seconds"
  },
  corp: {
    name: "Corporate",
    brn: "BRN",
    code: "Code",
    create: "Create Corporate",
    create_success: "Successfully created the corporate",
    create_fail: "Failed to create corporate"
  },
  package: {
    name: "Package",
    code: "Package Code",
    create: "Create Package",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "Successfully created the package",
    create_fail: "Failed to create package"
  },
  number: {
    type: "Number Type",
    add: "Add Number",
    pilot: "Company Number",
    agent: "User Number",
    charge: "Charge Number",
    syncpackage: "Sync Package for all",
    create_success: "Successfully created the Number",
    agent_create: "Create User Number",
    pilot_create: "Create Company Number",
    pilot_create_success: "Successfully created the Company Number",
    pilot_create_fail: "Failed to create the Company Number",
    agent_create_success: "Successfully created the User Number",
    agent_create_fail: "Failed to create the User Number",
    bgadmin_login_fail: "Login BG Admin Failed",
    comportal_login_fail: "Login Comm Portal Failed",
    sync_package_success: "Sync package successed",
    alternative: "Alternative Number",
    main_ivr: "Main IVR",
    real: "Real Number",
    mapping: "Mapping Number"
  },
  voicemail: {
    name: "Voice Mail",
    to: "to",
    from: "from",
    date: "date",
    corp: "Corporate"
  },
  report: {
    chart_answer: "Answered (call)",
    chart_abandon: "Abandon (call)",
    chart_talk_time_avg: "AVG Talk Time (min)",
    chart_talk_time: "Talktime Per Day (min)",
    unit_call: " (calls)",
    unit_min: " (minute)",

    inbound_answer: "Answered Inbound",
    inbound_abandon: "Abandon Inbound",
    inbound_talk_time_avg: "AVG Talk Time",
    inbound_talk_time: "Talktime Per Day",

    outbound_answer: "Outgoing Call",
    outbound_abandon: "Abandon Outbound",
    outbound_talk_time_avg: "AVG Talk Time",
    outbound_talk_time: "Talktime Per Day",

    internal_answer: "Answered Internal",
    internal_abandon: "Abandon Internal",
    internal_talk_time_avg: "AVG Talk Time",
    internal_talk_time: "Talktime Per Day",
    menu: "Record Detail",
    charging_group: "Charging Group",
    export: "Export",
    type: "Type",
    enterprise_number: "Enterprise Number",
    number: "Number",
    enterprise: "Enterprise Name",
    enterprise_sub: "Enterprise Branch",
    type: "Type",
    cdr_report: "CDR report ",
    dashboard_report: "Dashboard Report ",
    performance_report_type: "Performance Report Type",
    performance_by_number: "Performance by number / agent",
    performance_by_group: "Performance by group",
    date: "date",
    start: "Start date",
    end: "End date",
    search: "Search ",
    call_type: "call type",
    outbound: "outbound",
    inbound: "inbound",
    internal: "internal",
    voicemail: "voicemail",
    all: "all",
    call_status: "call status",
    status_answered: "answered",
    status_no_answer: "no answer",
    corporate: "corporate",
    call_dates: "call dates",
    call_origination: "call origination",
    display_number: "display number",
    call_termination: "call termination",
    start_time: "start time",
    ringing: "ringing (second)",
    answered_time: "answered time",
    terminated_time: "terminated time",
    terminated_reason: "terminated reason",
    reason_change: "reason change",
    final_number: "Transferred destination number",
    duration: "duration (second)",
    total_call: "All transaction logs",
    answered: "All voice calls (outgoing and incoming)",
    unanswered:
      "ALL MISSED INCOMING CALLS, MISSED OUTGOING CALLS AND MISSED CALLS TO HUNTING GROUP",
    longest_waiting_time:
      "Longest call waiting time (including outgoing and incoming calls)",
    avg_waiting_time: "AVERAGE STAFF’S CALL WAITING TIME  (SECOND)",
    avg_talk_time: "Avg talk time (second)",
    call_volume: "Transaction logs per day",
    number_of_calls: "number of calls (calls)",
    talk_time:
      "All voice call duration including dtac OneCall connection duration",
    idle_time: "idle time",
    speed_of_answer: "speed of answer (second)",
    status: "Status",
    date_warning:
      "The maximum search period is 90 days. For query more than 30 days, it will take longer than usual.",
    data_start:
      "The system will display information from February 25, 2022 onwards.",
    call_voicemail: "Voicemail (calls)",
    no_number: "No Caller ID"
  },
  user: {
    create: "Create User",
    name: "Name",
    username: "Username",
    type: "Type",
    phone: "Phone",
    role: "Role",
    create_success: "Create User successed",
    create_fail: "Create User failed"
  },
  mlhg: {
    name: "Hunt Group",
    failed: "Hunt Group failed",
    success: "Hunt Group successed",
    pilot_number: "Pilot Number",
    pilot_number_type: "Pilot Number Type",
    pilot_number_dummy: "Dummy Number",
    pilot_number_real: "Real Number"
  },

  group_name: "Group Name",
  email: "E-Mail",
  email_optional: "E-Mail (Optional)",
  created: "Created",
  search: "Search",
  save: "Save",
  back: "Back",
  new: "New",
  status: "Status",
  download: "Download",
  downloadall: "Download All",
  search: "Search",
  welcome: "Welcome",
  myprofile: "Profile",
  changepassword: "Change Password",
  page_notfound: "Sorry Page not found.",
  page_notfound_desc: "Plase check URL again.",
  actions: "Menu",
  data: "Data ",
  to: "To",
  of: "Of",
  row_select: "rows selected",
  yes: "Yes",
  no: "No",
  ok: "Ok",
  cancel: "Cancel",
  upload_file: "Upload File",
  upload: "Upload",
  upload_number_success: "Upload number success.",
  bg_admin: "Admin Setting",
  comportal: "Agent Setting",
  add: "Add",
  import: "Import",
  clear: "Clear",
  close: "Close",
  please_select: "Please select..",
  create: "Create",
  confirm: "Confirm",
  create_success: "Create success",
  delete_confirm: "Confirm delete",
  delete_confirm_text: "Please confirm delete ",
  delete_confirm_question: "Do you want to delete this information ? ",
  delete_success: "Delete successed",
  delete_fail: "Delete Failed",
  edit_success: "Editing successed",
  edit_fail: "Editing failed",
  import_inprogress: "Import processing.",
  processing: "Processing"
};
